define('plugin/secure/SecurePlugin',['require','lib/plugin/PluginAbstract','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var Config = require('Config');

    return PluginAbstract.extend({

        initialize: function () {
            var location = document.location;
            if (location.protocol.indexOf('https') === -1) {
                var host = Config.getInstance().getOption('secure_url');
                var path = location.pathname + location.search + location.hash;

                document.location.replace(host + path);
            }
        }

    });

});
